import { parseJwt } from './parseJwt';

export const isOldToken = (token: string): boolean => {
  const payload = parseJwt(token);
  // An absent/unreadable token is not an OLD token: let the request
  // proceed so the normal 401 → re-auth flow handles it, matching the
  // guarded call sites (TELV1-551 / Sentry TELLET-DASHBOARD-5S).
  if (!payload) return false;
  return 'project_id' in payload || 'organization_id' in payload || 'conversation_id' in payload;
};
